import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "./screens/Authentication/LanguageContext";
import { AuthProvider } from "./screens/Authentication/AuthContext";
import MainStack from "./screens/MainScreen/MainStack";
import "./App.css";

export type WebsiteTheme = "light" | "dark";

const WEBSITE_THEME_KEY = "dear_language_website_theme";

const normalizeTheme = (value: string | null): WebsiteTheme => {
  return value === "dark" ? "dark" : "light";
};

const getStoredTheme = (): WebsiteTheme => {
  try {
    return normalizeTheme(window.localStorage.getItem(WEBSITE_THEME_KEY));
  } catch {
    return "light";
  }
};

const applyTheme = (theme: WebsiteTheme): void => {
  document.documentElement.setAttribute("data-theme", theme);

  document.body.classList.remove("website-theme-light", "website-theme-dark");
  document.body.classList.add(`website-theme-${theme}`);

  try {
    window.localStorage.setItem(WEBSITE_THEME_KEY, theme);
  } catch {
    // localStorage can be blocked.
  }

  window.dispatchEvent(
    new CustomEvent("dear-language-theme-change", {
      detail: { theme },
    }),
  );
};

const App: React.FC = () => {
  useEffect(() => {
    applyTheme(getStoredTheme());
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <MainStack />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
};

export default App;